module.exports = __webpack_public_path__ + "img/wok-shop_banner.9f2470c6.jpg";